import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../axiosInstance/axiosInstance";
import { ApiErrorResponse } from "../../../api/types/ApiErrorResponse";
import { toApiError } from "../../../api/utils/errorHandling";
import { CancellationPolicyResponse } from "../contracts/CancellationPolicyResponse";
import { SetCancellationPolicyRequest } from "../contracts/SetCancellationPolicyRequest";
import { toCancellationPolicy } from "../mappers/CancellationPolicyResponseMapper";
import { CancellationPolicy } from "../models/CancellationPolicy";

const URL = "/organizations/current/cancellation-policy";

/** Loads the organization's default cancellation policy (the built-in default when none is set). */
export const fetchCancellationPolicy = createAsyncThunk<
  CancellationPolicy,
  void,
  { rejectValue: ApiErrorResponse }
>("organization/fetchCancellationPolicy", async (_, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get<CancellationPolicyResponse>(URL);
    return toCancellationPolicy(response.data);
  } catch (error) {
    return rejectWithValue(toApiError(error, "Failed to load the cancellation policy"));
  }
});

/** Saves the organization's default cancellation policy (Owner/Admin). */
export const saveCancellationPolicy = createAsyncThunk<
  CancellationPolicy,
  SetCancellationPolicyRequest,
  { rejectValue: ApiErrorResponse }
>("organization/saveCancellationPolicy", async (request, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.put<CancellationPolicyResponse>(URL, request);
    return toCancellationPolicy(response.data);
  } catch (error) {
    return rejectWithValue(toApiError(error, "Failed to save the cancellation policy"));
  }
});
